import { PolicyReviewAtRenewalGetRequestQuery } from '@lio/api-types';

export const reviewAtRenewalQueryKeys = {
  resource: 'review-at-renewal' as const,
  get: (policyId?: string) => [reviewAtRenewalQueryKeys.resource, policyId] as const,
  searchWithParams: (policyId: string, params?: PolicyReviewAtRenewalGetRequestQuery) =>
    [...reviewAtRenewalQueryKeys.get(policyId), params] as const,
};
